/**
 * Labstep
 *
 * @module components/ExperimentWorkflowTemplate/Warning
 * @desc Display a warning for the user that they are viewing / editing a template.
 */

import type React from 'react';
import { Message } from 'semantic-ui-react';
import type { ExperimentWorkflowTemplateWarningProps } from './types';

export const ExperimentWorkflowTemplateWarning: React.FC<
  ExperimentWorkflowTemplateWarningProps
> = ({ experimentWorkflow }) =>
  experimentWorkflow?.is_template ? (
    <Message
      data-cy="components/ExperimentWorkflowTemplate/Warning"
      color="yellow"
    >
      This is a template.
    </Message>
  ) : null;
